import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4 -mt-2 text-xs font-bold text-left text-red-600"
}
const _hoisted_3 = { class: "grid grid-cols-2 gap-5 text-left" }
const _hoisted_4 = { class: "col-span-2" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4 -mt-2 text-xs font-bold text-left text-red-600"
}
const _hoisted_6 = { class: "grid grid-cols-2 gap-5 text-left" }
const _hoisted_7 = { class: "col-span-2" }
const _hoisted_8 = {
  key: 0,
  class: "mb-4 -mt-2 text-xs font-bold text-left text-red-600"
}
const _hoisted_9 = { class: "grid grid-cols-2 gap-5 text-left" }
const _hoisted_10 = { class: "col-span-2" }
const _hoisted_11 = { class: "col-span-2" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import EditFormSection from './EditFormSection.vue';
import CorporateEditFormSection from './CorporateEditFormSection.vue';
import EditSoftFormSection from './EditSoftFormSection.vue';
import ScheduleLogs from './ScheduleLogs.vue';
import TabComponent from '@/components/TabComponent.vue';
import MenuComponent from '@/components/MenuComponent.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import BookingService from '@/classes/BookingService';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import DropzoneInput from '@/components/inputs/DropzoneInput.vue';

import TextInput from '@/components/inputs/TextInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';

import RescheduleModal from './RescheduleModal.vue';

import { useRoute } from 'vue-router';
import { ref, computed, watch } from 'vue';
import { add } from 'date-fns';
import { useNetworkStore } from '@/store/network';

interface CancelPayload {
    booking_id: number,
    remarks   : string | null,
}

interface NoShowPayload {
    booking_id: number,
    remarks   : string | null,
}

interface DonePayload {
    booking_id: number,
    remarks   : string | null,
}

interface Time {
    hours  : number | null,
    minutes: number | null,
    seconds: number | null,
}

interface ReschedulePayload {
    booking_id        : number,
    booking_date      : string | Date,
    booking_start_time: Time | null,
    booking_end_time  : Time | null,
    remarks           : string | null,

    branch_id         : string | null,
    branch_name       : string | null,
    package_id        : string | null,
    package_name      : string | null,
    riders            : string | null,
}

const timezoneOffset = 8; // Philippines time zone is UTC+8

export default /*@__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const rescheduleAppointment = ref(false)
const cancelBooking         = ref(false)
const noShow                = ref(false)
const asDone                = ref(false)
const noteAndResult = ref(false)

const loader           = ref(false)
const showError        = ref(false)
const errorMsg         = ref()
const errors      = ref([])
const showSuccess      = ref(false)
const successMsg       = ref()

const route = useRoute();

const patient_type = ref(route.query.patient_type);
const schedule_logs = ref(route.query.schedule_logs);
const booking_id   = ref(Number(route.params.bookingId) as unknown as number);
const branch_id    = ref(Number(route.params.branchId) as unknown as number);

const branch_name = ref(null);
const package_id = ref(null);
const booking_date = ref(null);
const package_name = ref(null);
const riders = ref(null);
const corporate_booking_status = ref(null);

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const cancelPayload = ref<CancelPayload>({
    booking_id: booking_id.value,
    remarks   : null,
});

const noShowPayload = ref<NoShowPayload>({
    booking_id: booking_id.value,
    remarks   : null,
});

const donePayload = ref<DonePayload>({
    booking_id: booking_id.value,
    remarks   : null,
});

const reschedulePayload = ref<ReschedulePayload>({
    booking_id        : booking_id.value,
    booking_date      : add(new Date, {days: 3}),
    booking_start_time: null,
    booking_end_time  : null,
    remarks           : null,

    branch_id         : null,
    branch_name       : null,
    package_id        : null,
    package_name      : null,
    riders            : null,
});

const rawTestResult = ref(null)
const uploadNoteAndResultPayload = ref({
    booking_id: booking_id.value,
    doctors_note: null,
    lab_result_base_64: null,
    is_password_protected: null,
    pdf_password: null,
})

const selectedTime = ref(null)
const fullyBookedDates = ref([]);
const unformattedTimeSlots = ref([]);
const timeSlots = ref([]);

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth();
const threeDaysLater = new Date(currentDate.getTime() + 3 * 24 * 60 * 60 * 1000 + timezoneOffset * 60 * 60 * 1000); // For 3 days advance booking

const minDate = computed(() => threeDaysLater.toISOString().slice(0, 10));
const from = ref(null);
const to = ref(null);

const selectedDate = ref(minDate.value)

const formatTimeSlots = () => {
    timeSlots.value = [];
    for(const unformattedTimeSlot in unformattedTimeSlots.value) {
        unformattedTimeSlots.value[unformattedTimeSlot].forEach(slot => {
            if(slot.available_slots != 0) {
                if(!slot.is_blocked) {
                    timeSlots.value.push(slot);
                }
            }
        });

    }
}

const fetchDateAndTime = () => {
    loader.value = true

    const data = {
        branch_id: branch_id.value,
        selected_date: selectedDate.value,
        from: from.value,
        to: to.value,
    }

    BookingService.fetchDateAndTime(data)
        .then((result: any) => {
            loader.value = false;

            fullyBookedDates.value = result.data.response.fully_booked_dates;         
            unformattedTimeSlots.value = result.data.response.time_slots;         
            
            if(selectedDate.value) {
                formatTimeSlots();
            }
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            // errorMsg.value = error;
            errorMsg.value = error.response?.data?.message;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }

            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}

const updateMonth = (val = null) => {
    // Get First and Last Day for Active Month
    const monthYear = {
        year: currentYear,
        month: currentMonth,
    }

    from.value = firstDayOfMonth(val ? val : monthYear)
    to.value = lastDayOfMonth(val ? val : monthYear);

    // Fetch fetchDateAndTime for Active Month
    if(isNetworkAvailable.value) {
        fetchDateAndTime();
    }
}

const firstDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-01`;

    return formattedDate;
}

const lastDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const lastDay = new Date(year, month, 0).getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`;

    return formattedDate;    
}

// const timeTextHelper = computed(() => {
//     if(patient_type.value == 'Individual' || patient_type.value == 'Dependent') {
//         return 'E.g., 12:00 PM, 8:00 AM';
//     } else if (patient_type.value == 'Corporate'){
//         return 'E.g., 14:00:00, 08:00:00';
//     } else {
//         return null;
//     }
// })

const redirectToBookingIndex = () =>{
    window.location.assign(`/branches/${branch_id.value}/bookings/`)
}

const buildCancelPayload = () => {
    if(patient_type.value == 'Individual' || patient_type.value == 'Dependent') {
        return {
            booking_id: booking_id.value,
            remarks   : cancelPayload.value.remarks ?? 'Booking cancel remarks'
        };
    } else if (patient_type.value == 'Corporate'){
        return {
            corporate_booking_id: booking_id.value,
            booking_status: 'CANCEL',
            remarks             : cancelPayload.value.remarks
        };
    }

    return {};
}

const buildNoShowPayload = () => {
    if(patient_type.value == 'Individual' || patient_type.value == 'Dependent') {
        return {
            booking_id: booking_id.value,
            remarks   : noShowPayload.value.remarks ?? 'Booking no show remarks'
        };
    } else if (patient_type.value == 'Corporate'){
        return {
            corporate_booking_id: booking_id.value,
            booking_status: 'NO SHOW',
            remarks             : noShowPayload.value.remarks
        };
    }

    return {};
}

const buildDonePayload = () => {
    if(patient_type.value == 'Individual' || patient_type.value == 'Dependent') {
        return {
            // booking_id: booking_id.value,
            booking_list_id: [booking_id.value],
            remarks   : donePayload.value.remarks ?? 'Booking done remarks'
        };
    } else if (patient_type.value == 'Corporate'){
        return {
            corporate_booking_id: booking_id.value,
            remarks             : donePayload.value.remarks
        };
    }

    return {};
}

const submitCancelBooking = () => {
    loader.value = true;

    BookingService.submitCancelBooking(patient_type.value, buildCancelPayload())
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                cancelBooking.value = false;
                successMsg.value    = "Appointment has been successfully marked as cancelled";
                showSuccess.value   = true;
            } else if(result.data.response.result_status == 500) {
                cancelBooking.value = false;
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            } else if(result.data.response.result_status == 400) {
                cancelBooking.value = false;
                showError.value = true;
                errorMsg.value  = result.data?.response?.message;
            }
        })
        .catch((error: any) => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }

            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}

const submitMarkNoShow = () => {
    loader.value = true;

    BookingService.submitMarkNoShow(patient_type.value, buildNoShowPayload())
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                noShow.value = false;
                successMsg.value    = "Appointment has been successfully marked as no show";
                showSuccess.value   = true;
            } else if(result.data.response.result_status == 500) {
                noShow.value = false;
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            } else if(result.data.response.result_status == 400) {
                noShow.value = false;
                showError.value = true;
                errorMsg.value  = result.data?.response?.message;
            }
        })
        .catch((error: any) => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }

            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}

const submitMarkAsDone = () => {
    loader.value = true;

    BookingService.submitMarkAsDone(patient_type.value, buildDonePayload())
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                asDone.value = false;
                successMsg.value    = "Appointment has been successfully marked as done";
                showSuccess.value   = true;
            } else if(result.data.response.result_status == 500) {
                asDone.value = false;
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            } else if(result.data.response.result_status == 400) {
                asDone.value = false;
                showError.value = true;
                errorMsg.value  = result.data?.response?.message;
            }
        })
        .catch((error: any) => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }

            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}


const fetchedItem = (val) => {
    if(patient_type.value == 'Individual' || patient_type.value == 'Dependent') {
        branch_name.value = val.branch_name;
        package_id.value = val.package_id;
        package_name.value = val.package_name;
        corporate_booking_status.value = val.status;
        booking_date.value = val.booking_date;


        if(typeof val.other_charges_details == 'string') {
            riders.value = val.other_charges_details;
            return;
        }

        const rdrs = [];

        if(val.other_charges_details.length > 0) {
            val.other_charges_details[0].trans_line.forEach(element => {
                if(element.items) {
                    rdrs.push(element.items.description);
                }
            });
        }
        riders.value = rdrs;

    } else {
        branch_name.value = val.branch_name;
        package_id.value = val.package_id;
        package_name.value = val.package_name;
        corporate_booking_status.value = val.status;
        booking_date.value = val.booking_date;

        if(timeSlots.value.length > 0) {
            reschedulePayload.value.booking_start_time = new Date(`${new Date(reschedulePayload.value.booking_date).toISOString().split('T')[0]} ${timeSlots.value[0].start_time}`).toLocaleTimeString('en-US', {hour12: false});
            reschedulePayload.value.booking_end_time = new Date(`${new Date(reschedulePayload.value.booking_date).toISOString().split('T')[0]} ${timeSlots.value[timeSlots.value.length - 1].end_time}`).toLocaleTimeString('en-US', {hour12: false});
        }

        if(typeof val.other_charges_details == 'string') {
            riders.value = val.other_charges_details;
            return;
        }

        const rdrs = [];
        if(val.other_charges_details.length > 0) {
            val.other_charges_details.forEach(element => {
                    rdrs.push(element.item_name);
            });
        }
        riders.value = rdrs;
    }
}

const selectTimeSlot = (val) => {
    if(val) {
        reschedulePayload.value.booking_start_time = val.split('-')[0];
        reschedulePayload.value.booking_end_time = val.split('-')[1];
    }
}

const uploadNoteAndResult = () => {
    loader.value = true;

    BookingService.uploadNoteAndResult(uploadNoteAndResultPayload.value)
        .then((result: any) => {
            loader.value = false;

            noteAndResult.value = false;
            successMsg.value    = "Appointment has been successfully uploaded Doctor's Note / Test Tesult";
            showSuccess.value   = true;

            if(result.data.result_status == 500) {
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            }
        })
        .catch((error: any) => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }

            if(error.response.status == 403) {
                errorMsg.value = "You don't permission to view to page";
            }
        })
}

const success = ():void => {
    rescheduleAppointment.value = false;
    successMsg.value            = "Appointment has been successfully rescheduled";
    showSuccess.value           = true;
}
const tabs: { name: string, count: number, allowed: boolean }[] = computed(() => [
    {
        name: 'Information',
        count: 0,
        href: `/branches/${branch_id.value}/bookings/edit/${booking_id.value}?patient_type=${patient_type.value}`,
        allowed: true
    },
    {
        name: 'Schedule Logs',
        count: 0,
        href: `/branches/${branch_id.value}/bookings/edit/${booking_id.value}/schedule-logs/?patient_type=${patient_type.value}&schedule_logs=true`,
        allowed:
            (window.$hasPermission('view-individual-patient-schedule-logs') ||
            window.$hasPermission('view-corporate-patient-schedule-logs'))
    },
]);

const menu: { name: string, allowed: boolean }[] = [
    { 
        name: 'Reschedule', 
        allowed: 
            window.$hasPermission('update-individual-patient-appointment-time') || 
            window.$hasPermission('update-company-booking-date') ||
            window.$hasPermission('reschedule-corporate-bookings')
    },
    { 
        name: 'Cancel', 
        allowed: 
            window.$hasPermission('update-individual-patient-appointment-time') || 
            window.$hasPermission('update-company-booking-date') ||
            window.$hasPermission('cancel-corporate-bookings')
    },
    { 
        name: 'Mark as No Show', 
        allowed: 
            window.$hasPermission('update-individual-patient-appointment-time') || 
            window.$hasPermission('update-company-booking-date')
    },
    { 
        name: 'Mark as Done', 
        allowed: 
            window.$hasPermission('update-individual-patient-appointment-time') || 
            window.$hasPermission('update-company-booking-date')
    },
    // TODO : IF NEEDED
    // { 
    //     name: "Upload Doctor's Note and Test Result",
    //     allowed:
    //         true
    // },
];

watch(
    () => selectedDate.value,
    (val) => {
        if(val)
            selectedTime.value = null;
            reschedulePayload.value.booking_date = new Date(selectedDate.value).toISOString().split('T')[0];
            updateMonth();
    }
);

watch(
    () => selectedTime.value,
    (val) => {
        if(val)
        selectTimeSlot(val);
    }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Edit Booking",
    "show-back": "",
    backUrl: `/branches/${branch_id.value}/bookings`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, {
          tabs: tabs.value,
          "button-items": true
        }, _createSlots({ _: 2 }, [
          (isNetworkAvailable.value)
            ? {
                name: "buttons",
                fn: _withCtx(() => [
                  (
                            patient_type.value != 'Soft' && 
                            !schedule_logs.value && 
                            corporate_booking_status.value == 'Booked' &&
                            (
                                _ctx.$hasPermission('update-individual-patient-booking-status') || 
                                _ctx.$hasPermission('update-company-booking-status') ||
                                _ctx.$hasPermission('cancel-corporate-bookings') ||
                                _ctx.$hasPermission('reschedule-corporate-bookings')
                            ))
                    ? (_openBlock(), _createBlock(MenuComponent, {
                        key: 0,
                        menu: menu,
                        onClickMenu: _cache[0] || (_cache[0] = (name) => { 
                            name == 'Mark as Done' 
                            ? asDone.value = true 
                            :name == 'Mark as No Show' 
                            ? noShow.value = true 
                            : name == 'Cancel' 
                            ? cancelBooking.value = true 
                            : name == 'Reschedule'
                            ? rescheduleAppointment.value = true
                            : noteAndResult.value = true
                        })
                      }))
                    : _createCommentVNode("", true)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["tabs"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        (!schedule_logs.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (patient_type.value == 'Individual' || patient_type.value == 'Dependent')
                ? (_openBlock(), _createBlock(EditFormSection, {
                    key: 0,
                    onFetchedItem: fetchedItem,
                    isNetworkAvailable: isNetworkAvailable.value
                  }, null, 8, ["isNetworkAvailable"]))
                : _createCommentVNode("", true),
              (patient_type.value == 'Corporate')
                ? (_openBlock(), _createBlock(CorporateEditFormSection, {
                    key: 1,
                    onFetchedItem: fetchedItem,
                    isNetworkAvailable: isNetworkAvailable.value
                  }, null, 8, ["isNetworkAvailable"]))
                : _createCommentVNode("", true),
              (patient_type.value == 'Soft' || patient_type.value == 'soft')
                ? (_openBlock(), _createBlock(EditSoftFormSection, {
                    key: 2,
                    isNetworkAvailable: isNetworkAvailable.value
                  }, null, 8, ["isNetworkAvailable"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (schedule_logs.value)
          ? (_openBlock(), _createBlock(ScheduleLogs, {
              key: 1,
              "booking-id": booking_id.value
            }, null, 8, ["booking-id"]))
          : _createCommentVNode("", true)
      ]),
      (rescheduleAppointment.value)
        ? (_openBlock(), _createBlock(RescheduleModal, {
            key: 0,
            show: rescheduleAppointment.value,
            bookingId: booking_id.value,
            branchId: branch_id.value,
            bookingDate: booking_date.value,
            bookingType: patient_type.value,
            package: package_name.value,
            riders: riders.value,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (rescheduleAppointment.value = false)),
            onSuccess: success
          }, null, 8, ["show", "bookingId", "branchId", "bookingDate", "bookingType", "package", "riders"]))
        : _createCommentVNode("", true),
      _createVNode(ConfirmationModal, {
        show: cancelBooking.value,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (cancelBooking.value = false)),
        onConfirm: submitCancelBooking,
        "cancel-text": "Cancel",
        "action-text": "Submit",
        title: "Cancel Booking?",
        content: "Are you sure you wish to mark this booking as cancelled?"
      }, {
        fields: _withCtx(() => [
          (patient_type.value != 'Individual')
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" WARNING: Canceling/Rescheduling a Company Booking will affect ", -1),
                _createElementVNode("br", null, null, -1),
                _createTextVNode(" all bookings associated with it. ", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(TextInput, {
                modelValue: cancelPayload.value.remarks,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cancelPayload.value.remarks) = $event)),
                label: "Reason",
                placeholder: "Reason"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: noShow.value,
        onCancel: _cache[5] || (_cache[5] = ($event: any) => (noShow.value = false)),
        onConfirm: submitMarkNoShow,
        "cancel-text": "Cancel",
        "action-text": "Submit",
        title: "No Show Booking?",
        content: "Are you sure you wish to mark this booking as no show?"
      }, {
        fields: _withCtx(() => [
          (patient_type.value != 'Individual')
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [...(_cache[15] || (_cache[15] = [
                _createTextVNode(" WARNING: Mark as now show a Company Booking will affect ", -1),
                _createElementVNode("br", null, null, -1),
                _createTextVNode(" all bookings associated with it. ", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(TextInput, {
                modelValue: noShowPayload.value.remarks,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((noShowPayload.value.remarks) = $event)),
                label: "Reason",
                placeholder: "Reason"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: asDone.value,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (asDone.value = false)),
        onConfirm: submitMarkAsDone,
        "cancel-text": "Cancel",
        "action-text": "Submit",
        title: "Mark As Done?",
        content: "Are you sure you wish to mark this booking as done?"
      }, {
        fields: _withCtx(() => [
          (patient_type.value != 'Individual')
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [...(_cache[16] || (_cache[16] = [
                _createTextVNode(" WARNING: Mark as done a Booking will affect ", -1),
                _createElementVNode("br", null, null, -1),
                _createTextVNode(" all bookings associated with it. ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: noteAndResult.value,
        onCancel: _cache[9] || (_cache[9] = ($event: any) => (noteAndResult.value = false)),
        onConfirm: uploadNoteAndResult,
        "cancel-text": "Cancel",
        "action-text": "Submit",
        title: "Upload Doctor's Note / Test Result?",
        content: "Are you sure you wish to update this appointment?"
      }, {
        fields: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(TextInput, {
                modelValue: uploadNoteAndResultPayload.value.doctors_note,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((uploadNoteAndResultPayload.value.doctors_note) = $event)),
                label: "Doctor's Note",
                placeholder: "Doctor's Note"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(DropzoneInput, {
                label: "Test Result",
                description: "PDF file",
                modelValue: rawTestResult.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((rawTestResult).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[10] || (_cache[10] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[11] || (_cache[11] = ($event: any) => (redirectToBookingIndex())),
        "action-text": "Confirm",
        title: "Appointment Updated!",
        content: successMsg.value
      }, null, 8, ["show", "content"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[12] || (_cache[12] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[13] || (_cache[13] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["backUrl"]))
}
}

})